var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-proyectos-documentos"}},[_c('listado-proyecto-documentos-desktop',{attrs:{"idProyecto":_vm.idProyecto}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }